import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getArticles = (params = {}) =>
  client.get("/articles", { params }).then((r) => r.data);

export const getArticle = (slug) =>
  client.get(`/articles/${slug}`).then((r) => r.data);

export const getCategories = () =>
  client.get("/categories").then((r) => r.data);

export const subscribe = (email) =>
  client.post("/newsletter", { email }).then((r) => r.data);

export const sendContact = (payload) =>
  client.post("/contact", payload).then((r) => r.data);

export const CATEGORY_STYLES = {
  dogs: "bg-[#DDA77B]/25 text-[#B07C4F]",
  cats: "bg-[#839788]/25 text-[#5C6B5F]",
  birds: "bg-[#D96B43]/20 text-[#D96B43]",
  "small-pets": "bg-[#EAE4D9] text-[#576054]",
};

export const CATEGORY_LABELS = {
  dogs: "Dogs",
  cats: "Cats",
  birds: "Birds",
  "small-pets": "Small Pets",
};
